import { useContext } from "react"
import BreakpointContext from "context/BreakpointContext"

export const useBreakpoint = () => {
  const { isLarge, isMedium } = useContext(BreakpointContext)
  return { isLarge, isMedium }
}

export default useBreakpoint
